<template>
  <b-modal
    ref="my-modal"
    scrollable
    centered
    hovered
    no-close-on-backdrop
    header-bg-variant="light"
    footer-bg-variant="light"
    size="lg"
    button-size="sm"
  >
    <template #modal-header="">
      <h5>FILE OF CREDIT CARDS</h5>
      <b-button size="sm" variant="outline-primary">
        <strong> {{ currentDivision }}</strong>
      </b-button>
    </template>
    <b-table
      hover
      striped
      select-mode="single"
      small
      sticky-header
      :items="items"
      :fields="fields"
      :busy="isBusy"
      head-variant="dark"
      class="mt-3"
      bordered
      style="max-height: 500px"
      ref="selectableTable"
      selectable
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
    </b-table>
    <template #modal-footer="{}">
      <div class="w-100">
        <!-- <p class="float-left">
          <strong> Count: {{ count }}</strong>
        </p> -->
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button
          class="float-right"
          size="sm"
          variant="secondary"
          @click="goHome()"
        >
          go Back
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import axios from "axios";

export default {
  name: "CreditCards",
  data: function () {
    return {
      url: "https://www.imandrades.com/apiIMA/tarjetas.php?action=",
      tarjetas: {},
      isBusy: false,
      fields: [
        { key: "banco", label: "Bank", class: "text-left" },
        { key: "tipo", label: "Card Type", class: "text-center" },
        { key: "numero", label: "Card Number", class: "text-center" },
        { key: "nombre", label: "Assigned to", class: "text-left" },
      ],
      items: [],
    };
  },
  mounted() {
    this.$refs["my-modal"].show();
    this.leerTarjetas();
  },
  methods: {
    goHome() {
      this.$router.push("menuDesktop");
    },
    leerTarjetas: async function () {
      this.isBusy = true;
      try {
        let respuesta = await axios.get(this.url + "getTarjetas");
        this.tarjetas = respuesta.data.tarjetas;
        this.tarjetas.forEach((card) => {
          this.items.push(card);
        });
        /* console.log(this.items); */
        this.isBusy = false;
      } catch (error) {
        console.log("Error Leyendo Tarjetas de Credito");
      }
    },
  },
};
</script>

<style scoped>
.logo {
  display: flex;
  margin-top: 0;
  margin-left: 0;
}
</style>